// Assets
import logo from '../../assets/logo.svg';

// Config
import { appConfig } from '../../config/app.config';

import './header.scss';

interface HeaderProps {}

const Header: React.FunctionComponent<HeaderProps> = () => {
	function onLogoClick() {
		window.open(appConfig.APIBaseURL, '_blank');
	}

	return (
		<div className="header">
			<div className="header__logo">
				<img src={logo} alt="" style={{ cursor: 'pointer' }} onClick={onLogoClick} />
			</div>
		</div>
	);
};

export default Header;
